import { render } from "./SalesEditGallery.vue?vue&type=template&id=0c469f02&scoped=true"
import script from "./SalesEditGallery.vue?vue&type=script&lang=js"
export * from "./SalesEditGallery.vue?vue&type=script&lang=js"

import "./SalesEditGallery.vue?vue&type=style&index=0&id=0c469f02&lang=scss&scoped=true"

import exportComponent from "D:\\main\\spacelab\\cinema-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c469f02"]])

export default __exports__